import { render, staticRenderFns } from "./DialogBtn.vue?vue&type=template&id=a45ae1e2&scoped=true"
import script from "./DialogBtn.vue?vue&type=script&lang=js"
export * from "./DialogBtn.vue?vue&type=script&lang=js"
import style0 from "./DialogBtn.vue?vue&type=style&index=0&id=a45ae1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ae1e2",
  null
  
)

export default component.exports